import React, { Component } from 'react'
import { Button, Dropdown, Icon } from '@softwaredev_cegeka/stix-core'
import { authenticatedUserStore } from 'src/stores'
import { OrganizationMenu } from './index'
import { observer } from 'mobx-react'
import AuthenticatedUserStore from 'src/stores/AuthenticatedUserStore'

import './userMenu.scss'

const { ORGANIZATION } = AuthenticatedUserStore.IMPERSONATE

const AvatarButton = React.forwardRef((props, ref) => {
    return (
        <Button variant="primary" {...props}>
            {authenticatedUserStore.userData?.firstName ? (
                <div className={'user-data-wrapper'}>
                    <span className={'user-first-last-name'}>
                        {authenticatedUserStore.firstName}{' '}
                        {authenticatedUserStore.lastName}
                    </span>
                    {authenticatedUserStore.impersonated[ORGANIZATION] &&
                    authenticatedUserStore.impersonatedOrganization ? (
                        <span className={'impersonated-tenant'}>
                            {authenticatedUserStore.impersonatedOrganization}
                        </span>
                    ) : null}
                </div>
            ) : (
                ''
            )}
            <Icon icon={'user-outline'} />
            <Icon className={'chevron-down'} icon={'chevron-down'} />
        </Button>
    )
})

class UserMenu extends Component {
    componentDidMount() {
        this.getAppPermissions()
    }

    getAppPermissions = () => {
        authenticatedUserStore.getAppPermissions(
            authenticatedUserStore.username,
            null
        )
    }

    render() {
        const canGlobalAdmin = authenticatedUserStore.canGlobalAdmin
        return (
            <Dropdown className={'login-menu'} alignRight>
                <Dropdown.Toggle as={AvatarButton} id="user-dropdown-menu" />
                <Dropdown.Menu>
                    <OrganizationMenu />
                    <Dropdown.Divider />
                    {canGlobalAdmin !== true ? null : (
                        <>
                            <Dropdown.Item href="/global-admins/request">
                                Request global admin access
                            </Dropdown.Item>
                            <Dropdown.Divider />
                        </>
                    )}
                    <Dropdown.Item href="/logout">Logout</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        )
    }
}

export default observer(UserMenu)
